var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-4" },
    [
      _c(
        "v-card-title",
        [
          _vm._v(" Новая модель "),
          _c("v-spacer"),
          _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.close } },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c(
            "v-form",
            {
              attrs: { autocomplete: "off" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c("v-text-field", {
                attrs: { label: "Название модели" },
                model: {
                  value: _vm.item.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "name", $$v)
                  },
                  expression: "item.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { large: "", color: "primary", disabled: !_vm.isValid },
              on: { click: _vm.save },
            },
            [_vm._v("Далее")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }